export const PERIOD_GRANULARITY_VALUES = ['DAY', 'HALF_MONTH', 'MONTH', 'WEEK'] as const;

export type PeriodGranularity = (typeof PERIOD_GRANULARITY_VALUES)[number];
